module.exports = __webpack_public_path__ + "img/rateLev_1.bf7ceae0.svg";